import { __decorate, __metadata } from 'tslib';
import { $logger } from '../../controllers/logger/logger.js';
import { WorkbenchContext } from '../../controllers/workbench/context.js';
import { Service } from '../../decorators/class/service.js';
import { EventEmitter } from '../event-emitter/event-emitter.js';

/**
 * 工作台上下文服务，用于获取上下文
 *
 * @public
 */
let ContextService = class ContextService {
    constructor(workbenchContext, eventEmitter) {
        this.workbenchContext = workbenchContext;
        this.eventEmitter = eventEmitter;
    }
    get context() {
        return this.workbenchContext;
    }
    /**
     * 向工作台上下文注入所需要的实例、对象或方法
     * 同一个 key 仅能注入一次
     *
     * @param key - 注入上下文的 key
     * @param value - 注入上下文的值，建议是个方法以方便获取最新值
     */
    inject(key, value) {
        if (key in WorkbenchContext.prototype) {
            $logger.error(`Duplicate injection for key: ${key}`);
            return;
        }
        let getter = () => value;
        if (typeof value === 'function') {
            getter = value;
        }
        Object.defineProperty(WorkbenchContext.prototype, key, {
            get: getter,
        });
        this.eventEmitter.emit('$onInjectContext', { key, value });
    }
};
ContextService = __decorate([
    Service(),
    __metadata("design:paramtypes", [WorkbenchContext, EventEmitter])
], ContextService);

export { ContextService };
//# sourceMappingURL=context-service.js.map
